import React from "react";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Stack,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import WifiIcon from "@mui/icons-material/Wifi";
import PersonIcon from "@mui/icons-material/Person";
import ConexionWifi from "./ConexionWifi.png";

const WifiInfoPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detecta si
  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Card elevation={3}>
        <CardContent>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            mb={2}
          >
            <WifiIcon color="primary" />
            <Typography variant="h5" fontWeight="bold">
              ¿Cómo acceder al WiFi como estudiante?
            </Typography>
          </Stack>

          <Typography variant="body1" gutterBottom>
            Para conectarte al internet institucional, sigue los
            siguientes pasos:
          </Typography>

          <Box component="ol" sx={{ pl: 3 }}>
            <li>
              <Typography>
                🔌 Conéctate a la red WiFi llamada{" "}
                <strong>CONTA_PUES</strong>.
              </Typography>
            </li>
            <li>
              <Typography>
                🌐 Al conectarte, se abrirá automáticamente una página
                de inicio de sesión.
              </Typography>
            </li>
            <Box
              sx={{
                width: { xs: 240, sm: "40%" },
                height: { xs: "auto", sm: "auto" },
                flexShrink: 0,
                order: isMobile ? 1 : 0,
                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.1)",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <img
                src={ConexionWifi}
                alt="Feria Profesiográfica UTO"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
            <li>
              <Typography>
                🧾 Ingresa tu <strong>usuario</strong> y{" "}
                <strong>contraseña</strong> siguiendo este formato:
              </Typography>
            </li>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="body1" gutterBottom>
            El <strong>usuario</strong> y la{" "}
            <strong>contraseña</strong> son iguales y se generan así:
          </Typography>

          <Box component="ul" sx={{ pl: 3 }}>
            <li>
              <Typography>
                ✅ 2 primeras letras del{" "}
                <strong>apellido paterno</strong>
              </Typography>
            </li>
            <li>
              <Typography>
                ✅ + 2 primeras letras del{" "}
                <strong>apellido materno</strong>
              </Typography>
            </li>
            <li>
              <Typography>
                ✅ + 4 últimas letras del{" "}
                <strong>primer nombre</strong>
              </Typography>
            </li>
            <li>
              <Typography>
                ✅ + <strong>año de nacimiento</strong> (4 dígitos)
              </Typography>
            </li>
          </Box>

          <Typography sx={{ mt: 2 }}>
            👉 Todo en <strong>mayúsculas</strong>, sin espacios ni
            tildes.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Card
            variant="outlined"
            sx={{
              backgroundColor: "#f5f5f5",
              p: 2,
              borderLeft: "4px solid #1976d2",
            }}
          >
            <Typography fontWeight="bold" gutterBottom>
              📌 Ejemplo correcto:
            </Typography>
            <Typography>
              Nombre: Carlos Fernando <strong>López Ramírez</strong>,
              nacido en <strong>2003</strong>
            </Typography>
            <Typography sx={{ mt: 1 }}>
              Usuario y contraseña: <strong>LORARLOS2003</strong>
            </Typography>
          </Card>

          <Divider sx={{ my: 3 }} />

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            mb={1}
          >
            <PersonIcon color="secondary" />
            <Typography variant="h6" fontWeight="bold">
              ¿Y los docentes?
            </Typography>
          </Stack>

          <Typography variant="body1">
            👩‍🏫 Los <strong>49 docentes</strong> del departamento
            también se benefician, accediendo directamente con su
            número de <strong>carnet de identidad</strong> como
            usuario y contraseña.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default WifiInfoPage;
